import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { CONDITION_CATEGORIES_ACTION_TYPE } from '../actions/conditionCategories.actions';

const initialState = [];

const conditionCategoriesReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case CONDITION_CATEGORIES_ACTION_TYPE.GET_CONDITION_CATEGORIES:
        return payload;

      case CONDITION_CATEGORIES_ACTION_TYPE.ADD_CONDITION_CATEGORY:
        draft.push(payload);
        break;

      case CONDITION_CATEGORIES_ACTION_TYPE.UPDATE_CONDITION_CATEGORY: {
        const index = draft.findIndex(c => c.id === payload.id);

        if (index !== -1) {
          draft[index] = payload;
        }

        break;
      }

      case CONDITION_CATEGORIES_ACTION_TYPE.DELETE_CONDITION_CATEGORY:
        return state.filter(c => c.id !== payload);

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default conditionCategoriesReducer;
